import {
	EMPTY_TIME,
	INVALID_DATE,
	INVALID_TIME_RANGE,
} from '../../../../../../../../common/ui/constants.tsx';
import {
	isEmpty,
	isInvalidFormat,
	toMilliseconds,
} from '../../../../../../../../common/utils/time/index.tsx';

export const getValidateFunction =
	(fieldIdPrefix: string, fieldId: number) =>
	(
		start: string,
		formData: {
			[key: string]: string;
		},
	) => {
		const end = formData[`${fieldIdPrefix}-end-${fieldId}`];

		if (isEmpty(start)) {
			return EMPTY_TIME;
		}

		if (isEmpty(start) || isInvalidFormat(start)) {
			return INVALID_DATE;
		}

		// don't compare times if connected end date is invalid
		if (isEmpty(end) || isInvalidFormat(end)) {
			return undefined;
		}

		if (toMilliseconds(start) >= toMilliseconds(end)) {
			return INVALID_TIME_RANGE;
		}

		return undefined;
	};
